"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// export interface Schedules {
//   schedules: SkuSchedule[];
// }
var LessonStatus;
(function (LessonStatus) {
    LessonStatus[LessonStatus["COMING"] = 0] = "COMING";
    LessonStatus[LessonStatus["LOCKED"] = 1] = "LOCKED";
    LessonStatus[LessonStatus["UNLOCKED"] = 2] = "UNLOCKED";
    LessonStatus[LessonStatus["HIGHLIGHT"] = 3] = "HIGHLIGHT";
    LessonStatus[LessonStatus["PLAYED"] = 4] = "PLAYED";
})(LessonStatus = exports.LessonStatus || (exports.LessonStatus = {}));
var LessonType;
(function (LessonType) {
    LessonType[LessonType["UNKNOWN"] = 0] = "UNKNOWN";
    LessonType[LessonType["LESSON"] = 1] = "LESSON";
    LessonType[LessonType["EXERCISE"] = 2] = "EXERCISE";
    LessonType[LessonType["REVIEW"] = 3] = "REVIEW";
})(LessonType = exports.LessonType || (exports.LessonType = {}));
var TeachingPointType;
(function (TeachingPointType) {
    TeachingPointType[TeachingPointType["KNOWLEDGE_POINT"] = 0] = "KNOWLEDGE_POINT";
    TeachingPointType[TeachingPointType["CONGNITIVE_PROCESS"] = 1] = "CONGNITIVE_PROCESS";
    TeachingPointType[TeachingPointType["APPLY_ABILITY"] = 2] = "APPLY_ABILITY";
})(TeachingPointType = exports.TeachingPointType || (exports.TeachingPointType = {}));
//# sourceMappingURL=course.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/course.js
// module id = 445
// module chunks = 0